/**
 * apps/web/src/components/Wordmark.tsx
 *
 * The glarno wordmark: an accent dot mark + the name set in the display face.
 * Used in the sidebar header and the login screen.
 */

import type React from 'react';
import { cn } from '../lib/cn';
import { useStrings } from '../i18n';

interface WordmarkProps {
  readonly className?: string;
  readonly size?: 'md' | 'lg';
}

export function Wordmark({ className, size = 'md' }: WordmarkProps): React.ReactElement {
  const strings = useStrings();
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <span
        className={cn(
          'inline-block rounded-full bg-accent',
          size === 'lg' ? 'h-3 w-3' : 'h-2.5 w-2.5',
        )}
        aria-hidden="true"
      />
      <span
        className={cn(
          'font-display font-bold tracking-tight text-accent',
          size === 'lg' ? 'text-2xl' : 'text-xl',
        )}
      >
        {strings.app.name}
      </span>
    </span>
  );
}
